import type { ProviderFetchResponse } from "@dealer-center/ddc-pages-inventory-archiver-interface";
import { useQuery } from "@tanstack/react-query";

const queryKeyBase = "ddc-pages-inventory-archiver-providers";

const fetchProvidersForAccount = async (
  accountName: string
): Promise<ProviderFetchResponse> => {
  const res = await fetch(
    "/invsup/nxlambda/inventoryArchiver/getProviders/pre/" + accountName
  );
  if (res.ok) {
    return res.json();
  } else {
    throw new Error(res.statusText);
  }
};

export function useGetAccountProviders(accountName: string) {
  return useQuery({
    queryKey: [queryKeyBase, { accountName }],
    queryFn: () => fetchProvidersForAccount(accountName.trim()),
    enabled: !!accountName && accountName.trim().length > 0
  });
}
